/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessInputBody,
  CreateInputBody4,
  ErrorModel,
  MoveInputBody1,
  PageBody,
  PagesCreateParams,
  PagesTreeParams,
  TreeOutputBody,
  UpdateInputBody1
} from '../model';

import { apiFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type pagesTreeResponse200 = {
  data: TreeOutputBody
  status: 200
}

export type pagesTreeResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesTreeResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesTreeResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesTreeResponseSuccess = (pagesTreeResponse200) & {
  headers: Headers;
};
export type pagesTreeResponseError = (pagesTreeResponse404 | pagesTreeResponse422 | pagesTreeResponse500) & {
  headers: Headers;
};

export type pagesTreeResponse = (pagesTreeResponseSuccess | pagesTreeResponseError)

export const getPagesTreeUrl = (slug: string,
    params?: PagesTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/workspaces/${slug}/pages?${stringifiedParams}` : `/workspaces/${slug}/pages`
}

/**
 * Плоский список видимых страниц уровня; дерево собирается по parent_id. Скрытая страница прячет и своих потомков.
 * @summary Страницы организации или проекта
 */
export const pagesTree = async (slug: string,
    params?: PagesTreeParams, options?: Parameters<typeof apiFetch>[1]): Promise<pagesTreeResponse> => {

  return apiFetch<pagesTreeResponse>(getPagesTreeUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPagesTreeQueryKey = (slug: string,
    params?: PagesTreeParams,) => {
    return [
    `/workspaces/${slug}/pages`, ...(params ? [params] : [])
    ] as const;
    }


export const getPagesTreeQueryOptions = <TData = Awaited<ReturnType<typeof pagesTree>>, TError = ErrorModel>(slug: string,
    params?: PagesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesTreeQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesTree>>> = ({ signal }) => pagesTree(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesTreeQueryResult = NonNullable<Awaited<ReturnType<typeof pagesTree>>>
export type PagesTreeQueryError = ErrorModel


export function usePagesTree<TData = Awaited<ReturnType<typeof pagesTree>>, TError = ErrorModel>(
 slug: string,
    params: undefined |  PagesTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesTree>>,
          TError,
          Awaited<ReturnType<typeof pagesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesTree<TData = Awaited<ReturnType<typeof pagesTree>>, TError = ErrorModel>(
 slug: string,
    params?: PagesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesTree>>,
          TError,
          Awaited<ReturnType<typeof pagesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesTree<TData = Awaited<ReturnType<typeof pagesTree>>, TError = ErrorModel>(
 slug: string,
    params?: PagesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Страницы организации или проекта
 */

export function usePagesTree<TData = Awaited<ReturnType<typeof pagesTree>>, TError = ErrorModel>(
 slug: string,
    params?: PagesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesTreeQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pagesCreateResponse201 = {
  data: PageBody
  status: 201
}

export type pagesCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type pagesCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesCreateResponseSuccess = (pagesCreateResponse201) & {
  headers: Headers;
};
export type pagesCreateResponseError = (pagesCreateResponse403 | pagesCreateResponse404 | pagesCreateResponse422 | pagesCreateResponse500) & {
  headers: Headers;
};

export type pagesCreateResponse = (pagesCreateResponseSuccess | pagesCreateResponseError)

export const getPagesCreateUrl = (slug: string,
    params?: PagesCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/workspaces/${slug}/pages?${stringifiedParams}` : `/workspaces/${slug}/pages`
}

/**
 * Участник и выше. Новая страница открыта всем, кто видит уровень.
 * @summary Создать страницу
 */
export const pagesCreate = async (slug: string,
    createInputBody4: NonReadonly<CreateInputBody4>,
    params?: PagesCreateParams, options?: Parameters<typeof apiFetch>[1]): Promise<pagesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<pagesCreateResponse>(getPagesCreateUrl(slug,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody4)
  }
);}





export const getPagesCreateQueryKey = (slug: string,
    createInputBody4?: NonReadonly<CreateInputBody4>,
    params?: PagesCreateParams,) => {
    return [
    'POST', `/workspaces/${slug}/pages`, ...(params ? [params] : []), createInputBody4
    ] as const;
    }


export const getPagesCreateQueryOptions = <TData = Awaited<ReturnType<typeof pagesCreate>>, TError = ErrorModel>(slug: string,
    createInputBody4: NonReadonly<CreateInputBody4>,
    params?: PagesCreateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesCreateQueryKey(slug,createInputBody4,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesCreate>>> = ({ signal }) => pagesCreate(slug,createInputBody4,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof pagesCreate>>>
export type PagesCreateQueryError = ErrorModel


export function usePagesCreate<TData = Awaited<ReturnType<typeof pagesCreate>>, TError = ErrorModel>(
 slug: string,
    createInputBody4: NonReadonly<CreateInputBody4>,
    params: undefined |  PagesCreateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesCreate>>,
          TError,
          Awaited<ReturnType<typeof pagesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesCreate<TData = Awaited<ReturnType<typeof pagesCreate>>, TError = ErrorModel>(
 slug: string,
    createInputBody4: NonReadonly<CreateInputBody4>,
    params?: PagesCreateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesCreate>>,
          TError,
          Awaited<ReturnType<typeof pagesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesCreate<TData = Awaited<ReturnType<typeof pagesCreate>>, TError = ErrorModel>(
 slug: string,
    createInputBody4: NonReadonly<CreateInputBody4>,
    params?: PagesCreateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Создать страницу
 */

export function usePagesCreate<TData = Awaited<ReturnType<typeof pagesCreate>>, TError = ErrorModel>(
 slug: string,
    createInputBody4: NonReadonly<CreateInputBody4>,
    params?: PagesCreateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesCreateQueryOptions(slug,createInputBody4,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pagesDeleteResponse204 = {
  data: void
  status: 204
}

export type pagesDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type pagesDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesDeleteResponseSuccess = (pagesDeleteResponse204) & {
  headers: Headers;
};
export type pagesDeleteResponseError = (pagesDeleteResponse403 | pagesDeleteResponse404 | pagesDeleteResponse422 | pagesDeleteResponse500) & {
  headers: Headers;
};

export type pagesDeleteResponse = (pagesDeleteResponseSuccess | pagesDeleteResponseError)

export const getPagesDeleteUrl = (slug: string,
    pageId: string,) => {




  return `/workspaces/${slug}/pages/${pageId}`
}

/**
 * Вместе с вложенными. Владелец, администратор — или тот, кто её создал.
 * @summary Удалить страницу
 */
export const pagesDelete = async (slug: string,
    pageId: string, options?: Parameters<typeof apiFetch>[1]): Promise<pagesDeleteResponse> => {

  return apiFetch<pagesDeleteResponse>(getPagesDeleteUrl(slug,pageId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPagesDeleteQueryKey = (slug: string,
    pageId: string,) => {
    return [
    'DELETE', `/workspaces/${slug}/pages/${pageId}`
    ] as const;
    }


export const getPagesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof pagesDelete>>, TError = ErrorModel>(slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesDelete>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesDeleteQueryKey(slug,pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesDelete>>> = ({ signal }) => pagesDelete(slug,pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof pagesDelete>>>
export type PagesDeleteQueryError = ErrorModel


export function usePagesDelete<TData = Awaited<ReturnType<typeof pagesDelete>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesDelete>>,
          TError,
          Awaited<ReturnType<typeof pagesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesDelete<TData = Awaited<ReturnType<typeof pagesDelete>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesDelete>>,
          TError,
          Awaited<ReturnType<typeof pagesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesDelete<TData = Awaited<ReturnType<typeof pagesDelete>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesDelete>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить страницу
 */

export function usePagesDelete<TData = Awaited<ReturnType<typeof pagesDelete>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesDelete>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesDeleteQueryOptions(slug,pageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pagesGetResponse200 = {
  data: PageBody
  status: 200
}

export type pagesGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesGetResponseSuccess = (pagesGetResponse200) & {
  headers: Headers;
};
export type pagesGetResponseError = (pagesGetResponse404 | pagesGetResponse422 | pagesGetResponse500) & {
  headers: Headers;
};

export type pagesGetResponse = (pagesGetResponseSuccess | pagesGetResponseError)

export const getPagesGetUrl = (slug: string,
    pageId: string,) => {




  return `/workspaces/${slug}/pages/${pageId}`
}

/**
 * Недоступная страница отвечает 404, как и несуществующая.
 * @summary Страница
 */
export const pagesGet = async (slug: string,
    pageId: string, options?: Parameters<typeof apiFetch>[1]): Promise<pagesGetResponse> => {

  return apiFetch<pagesGetResponse>(getPagesGetUrl(slug,pageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPagesGetQueryKey = (slug: string,
    pageId: string,) => {
    return [
    `/workspaces/${slug}/pages/${pageId}`
    ] as const;
    }


export const getPagesGetQueryOptions = <TData = Awaited<ReturnType<typeof pagesGet>>, TError = ErrorModel>(slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesGetQueryKey(slug,pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesGet>>> = ({ signal }) => pagesGet(slug,pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesGetQueryResult = NonNullable<Awaited<ReturnType<typeof pagesGet>>>
export type PagesGetQueryError = ErrorModel


export function usePagesGet<TData = Awaited<ReturnType<typeof pagesGet>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesGet>>,
          TError,
          Awaited<ReturnType<typeof pagesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesGet<TData = Awaited<ReturnType<typeof pagesGet>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesGet>>,
          TError,
          Awaited<ReturnType<typeof pagesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesGet<TData = Awaited<ReturnType<typeof pagesGet>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Страница
 */

export function usePagesGet<TData = Awaited<ReturnType<typeof pagesGet>>, TError = ErrorModel>(
 slug: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesGetQueryOptions(slug,pageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pagesUpdateResponse200 = {
  data: PageBody
  status: 200
}

export type pagesUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type pagesUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesUpdateResponseSuccess = (pagesUpdateResponse200) & {
  headers: Headers;
};
export type pagesUpdateResponseError = (pagesUpdateResponse403 | pagesUpdateResponse404 | pagesUpdateResponse422 | pagesUpdateResponse500) & {
  headers: Headers;
};

export type pagesUpdateResponse = (pagesUpdateResponseSuccess | pagesUpdateResponseError)

export const getPagesUpdateUrl = (slug: string,
    pageId: string,) => {




  return `/workspaces/${slug}/pages/${pageId}`
}

/**
 * @summary Изменить страницу
 */
export const pagesUpdate = async (slug: string,
    pageId: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>, options?: Parameters<typeof apiFetch>[1]): Promise<pagesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<pagesUpdateResponse>(getPagesUpdateUrl(slug,pageId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInputBody1)
  }
);}





export const getPagesUpdateQueryKey = (slug: string,
    pageId: string,
    updateInputBody1?: NonReadonly<UpdateInputBody1>,) => {
    return [
    'PATCH', `/workspaces/${slug}/pages/${pageId}`, updateInputBody1
    ] as const;
    }


export const getPagesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof pagesUpdate>>, TError = ErrorModel>(slug: string,
    pageId: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesUpdateQueryKey(slug,pageId,updateInputBody1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesUpdate>>> = ({ signal }) => pagesUpdate(slug,pageId,updateInputBody1, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof pagesUpdate>>>
export type PagesUpdateQueryError = ErrorModel


export function usePagesUpdate<TData = Awaited<ReturnType<typeof pagesUpdate>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesUpdate>>,
          TError,
          Awaited<ReturnType<typeof pagesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesUpdate<TData = Awaited<ReturnType<typeof pagesUpdate>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesUpdate>>,
          TError,
          Awaited<ReturnType<typeof pagesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesUpdate<TData = Awaited<ReturnType<typeof pagesUpdate>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить страницу
 */

export function usePagesUpdate<TData = Awaited<ReturnType<typeof pagesUpdate>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesUpdateQueryOptions(slug,pageId,updateInputBody1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pagesSetAccessResponse200 = {
  data: PageBody
  status: 200
}

export type pagesSetAccessResponse403 = {
  data: ErrorModel
  status: 403
}

export type pagesSetAccessResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesSetAccessResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesSetAccessResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesSetAccessResponseSuccess = (pagesSetAccessResponse200) & {
  headers: Headers;
};
export type pagesSetAccessResponseError = (pagesSetAccessResponse403 | pagesSetAccessResponse404 | pagesSetAccessResponse422 | pagesSetAccessResponse500) & {
  headers: Headers;
};

export type pagesSetAccessResponse = (pagesSetAccessResponseSuccess | pagesSetAccessResponseError)

export const getPagesSetAccessUrl = (slug: string,
    pageId: string,) => {




  return `/workspaces/${slug}/pages/${pageId}/access`
}

/**
 * Владелец и администратор. Они сами видят все страницы независимо от доступа.
 * @summary Кому открыта страница
 */
export const pagesSetAccess = async (slug: string,
    pageId: string,
    accessInputBody: NonReadonly<AccessInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<pagesSetAccessResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<pagesSetAccessResponse>(getPagesSetAccessUrl(slug,pageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(accessInputBody)
  }
);}





export const getPagesSetAccessQueryKey = (slug: string,
    pageId: string,
    accessInputBody?: NonReadonly<AccessInputBody>,) => {
    return [
    'PUT', `/workspaces/${slug}/pages/${pageId}/access`, accessInputBody
    ] as const;
    }


export const getPagesSetAccessQueryOptions = <TData = Awaited<ReturnType<typeof pagesSetAccess>>, TError = ErrorModel>(slug: string,
    pageId: string,
    accessInputBody: NonReadonly<AccessInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesSetAccess>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesSetAccessQueryKey(slug,pageId,accessInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesSetAccess>>> = ({ signal }) => pagesSetAccess(slug,pageId,accessInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesSetAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesSetAccessQueryResult = NonNullable<Awaited<ReturnType<typeof pagesSetAccess>>>
export type PagesSetAccessQueryError = ErrorModel


export function usePagesSetAccess<TData = Awaited<ReturnType<typeof pagesSetAccess>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    accessInputBody: NonReadonly<AccessInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesSetAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesSetAccess>>,
          TError,
          Awaited<ReturnType<typeof pagesSetAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesSetAccess<TData = Awaited<ReturnType<typeof pagesSetAccess>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    accessInputBody: NonReadonly<AccessInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesSetAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesSetAccess>>,
          TError,
          Awaited<ReturnType<typeof pagesSetAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesSetAccess<TData = Awaited<ReturnType<typeof pagesSetAccess>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    accessInputBody: NonReadonly<AccessInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesSetAccess>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Кому открыта страница
 */

export function usePagesSetAccess<TData = Awaited<ReturnType<typeof pagesSetAccess>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    accessInputBody: NonReadonly<AccessInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesSetAccess>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesSetAccessQueryOptions(slug,pageId,accessInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pagesMoveResponse200 = {
  data: PageBody
  status: 200
}

export type pagesMoveResponse403 = {
  data: ErrorModel
  status: 403
}

export type pagesMoveResponse404 = {
  data: ErrorModel
  status: 404
}

export type pagesMoveResponse422 = {
  data: ErrorModel
  status: 422
}

export type pagesMoveResponse500 = {
  data: ErrorModel
  status: 500
}

export type pagesMoveResponseSuccess = (pagesMoveResponse200) & {
  headers: Headers;
};
export type pagesMoveResponseError = (pagesMoveResponse403 | pagesMoveResponse404 | pagesMoveResponse422 | pagesMoveResponse500) & {
  headers: Headers;
};

export type pagesMoveResponse = (pagesMoveResponseSuccess | pagesMoveResponseError)

export const getPagesMoveUrl = (slug: string,
    pageId: string,) => {




  return `/workspaces/${slug}/pages/${pageId}/move`
}

/**
 * Новый родитель и место среди соседей. Страницу нельзя вложить в саму себя или в потомка.
 * @summary Переместить страницу
 */
export const pagesMove = async (slug: string,
    pageId: string,
    moveInputBody1: NonReadonly<MoveInputBody1>, options?: Parameters<typeof apiFetch>[1]): Promise<pagesMoveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<pagesMoveResponse>(getPagesMoveUrl(slug,pageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveInputBody1)
  }
);}





export const getPagesMoveQueryKey = (slug: string,
    pageId: string,
    moveInputBody1?: NonReadonly<MoveInputBody1>,) => {
    return [
    'POST', `/workspaces/${slug}/pages/${pageId}/move`, moveInputBody1
    ] as const;
    }


export const getPagesMoveQueryOptions = <TData = Awaited<ReturnType<typeof pagesMove>>, TError = ErrorModel>(slug: string,
    pageId: string,
    moveInputBody1: NonReadonly<MoveInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesMove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagesMoveQueryKey(slug,pageId,moveInputBody1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagesMove>>> = ({ signal }) => pagesMove(slug,pageId,moveInputBody1, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagesMove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagesMoveQueryResult = NonNullable<Awaited<ReturnType<typeof pagesMove>>>
export type PagesMoveQueryError = ErrorModel


export function usePagesMove<TData = Awaited<ReturnType<typeof pagesMove>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    moveInputBody1: NonReadonly<MoveInputBody1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesMove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesMove>>,
          TError,
          Awaited<ReturnType<typeof pagesMove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesMove<TData = Awaited<ReturnType<typeof pagesMove>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    moveInputBody1: NonReadonly<MoveInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesMove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagesMove>>,
          TError,
          Awaited<ReturnType<typeof pagesMove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagesMove<TData = Awaited<ReturnType<typeof pagesMove>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    moveInputBody1: NonReadonly<MoveInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesMove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Переместить страницу
 */

export function usePagesMove<TData = Awaited<ReturnType<typeof pagesMove>>, TError = ErrorModel>(
 slug: string,
    pageId: string,
    moveInputBody1: NonReadonly<MoveInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagesMove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagesMoveQueryOptions(slug,pageId,moveInputBody1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






